import React from "react";
import { Input } from "../../../../form-inputs/inputs";
import { AsyncTypeahead } from "../../../../form-inputs/typeahead";

const Ingredients = (props) => {
    const updateField = (name, value) => {
        const nameArr = name.split(".");
        props.updateField(nameArr[0], nameArr[1], value);
    };

    return (
        <div className="panel-group">
            <h3>Ingredients</h3>
            <Input name="ingredients.leadIn" label="Ingredients Lead-in" updateOnChange={updateField} value={props.data.leadIn} />

            <AsyncTypeahead
                name="ingredients.items"
                label="Ingredients"
                value={props.data.items}
                defaultValue={props.data.items}
                updateOnChange={updateField}
                provider="/picklists/ingredients/"
                multiple={true}
                creatable={true}
            />
        </div>
    );
};

export default Ingredients;
